<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Resumo geral'"
    [titleIcon]="'pi pi-chart-bar'"
    [subtitle]="'Informações gerais dos seus eventos desde o início.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Resumo geral', icon: 'pi pi-chart-bar' },
    ]"></app-page-header>
  <ng-container>
    <div class="container-fluid producer-area">
      <section class="area-cards">
        @if (wallet$ | async; as wallet) {
          <a [routerLink]="['/wallet']">
            <app-clickable-data-card
              icon="currency"
              [data]="(wallet.sales_total | currency: 'BRL')!"
              title="Faturamento:"
              size="small" />
          </a>
          <a [routerLink]="['/wallet']">
            <app-clickable-data-card
              title="A receber:"
              [data]="(wallet.balance_not_released | currency: 'BRL')!"
              icon="currency"
              size="small" />
          </a>
          <a [routerLink]="['/wallet']">
            <app-clickable-data-card
              icon="wallet"
              [data]="(wallet.total_withdrawn | currency: 'BRL')!"
              title="Sacado:"
              size="small"
          /></a>
        } @else {
          <p-skeleton height="120px" />
          <p-skeleton height="120px" />
          <p-skeleton height="120px" />
        }
      </section>
      <section class="area-last-sales">
        <app-last-sales-page />
      </section>

      <section class="area-my-events">
        <app-last-events-page />
      </section>

      <section class="area-revenue">
        <app-revenue-graphic-page />
      </section>

      <section class="area-tickets">
        <app-tickets-info-page />
      </section>

      <section class="area-payment-chart">
        <app-payment-methods-chart-page />
      </section>

      <section class="area-channel-chart">
        <app-sales-channels-chart-page />
      </section>
    </div>
  </ng-container>
</app-layout>
